(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('HomeController', HomeController)
        /* .constant('DEFAULT_LATITUDE', "32.77059340204903")
        .constant('DEFAULT_LONGITUDE', "-96.83874469246176") */;

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$rootScope'];

    function HomeController($scope, Principal, LoginService, $state, $rootScope) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.appName = 'Fiberify';
        $rootScope.$on('authenticationSuccess', function () {
            getAccount();
            $rootScope.listAuthorities();
            //  validateStates();
        });

        vm.appName = $rootScope.APP_NAME;

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if (vm.isAuthenticated() == true) {
                    validateStates();
                }
            });
        }

        function validateStates() {
            if ($rootScope.has_ROLE_SUPER_ADMIN == true) {
                //$state.go('user-management');
                $state.go('tenant');
            } else if ($rootScope.has_ROLE_USER_ADMIN === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_VENDOR === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_HOD === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_CITY_MANAGER === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_BA === true) {
                $state.go('incident-dashboard');                
            } else if ($rootScope.has_ROLE_CITY_PLANNER === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_ASSISTANT_MANAGER === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_OA === true) {
                $state.go('incident-dashboard');                
            } else if ($rootScope.has_ROLE_TEAM_LEADER === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_NETWORK_ENGINEER === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_FE === true) {
                $state.go('incident-dashboard');                
            } else if ($rootScope.has_ROLE_FRT == true) {
                $state.go('tr-case');
            }  else if ($rootScope.has_ROLE_PATROLLER == true) {
                $state.go('tr-case');
                /* }else if($rootScope.has_ROLE_USER ==true){
                //$state.go('location-log');
                $state.go('tr-case'); */
            }/*  else if ($rootScope.has_ROLE_ROLLOUT_ADMIN == true) {
                $state.go('tr-project');
            } else if ($rootScope.has_ROLE_PLAN_ADMIN == true) {
                $state.go('tr-project');
            } */
        }


        function register() {
            $state.go('register');
        }

    }

})();